import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/price-history.module.css";
import HistoryItem from "./HistoryItem";

class History extends React.PureComponent {
    render() {
        const { listing } = this.props;
        const { history } = listing;

        return (
            <div className={css.priceHistory}>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Event</th>
                            <th>Price</th>
                            <th>$/Sqft</th>
                            <th>Source</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((item, index) => (
                            <HistoryItem
                                item={item}
                                listing={listing}
                                key={index}
                            />
                        ))}
                    </tbody>
                </table>

                <a href="#" className={css.reportButton}>
                    Report issue with price history
                </a>
            </div>
        );
    }
}

History.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default History;
